import styled from 'styled-components'

export const Image = styled.img`order: -1;`
export const Body = styled.p``